import { useTranslation } from 'react-i18next';
import { Typography } from '@ui/components';
import { cn } from '@ui/utils';
import { FC } from 'react';

import { CreditCardFormProps, CreditCardForm } from '../../../components/onboarding-top-up-balance';

export interface TopUpPaymentProps extends CreditCardFormProps {
  disabled?: boolean;
}

export const TopUpPayment: FC<TopUpPaymentProps> = (props) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-6">
      <Typography variant="h200" element="h2">
        {t('ONBOARDING.TOP_UP.CREDIT_CARD_FORM_HEADER')}
      </Typography>
      <div className="relative border-1 rounded-xl border-border-weak-hover w-full p-4">
        <CreditCardForm {...props} />
        <div
          className={cn(
            'absolute top-0 left-0 right-0 bottom-0 rounded-xl backdrop-blur-sm z-1 bg-dialog-backdrop/10 hidden',
            { block: !!props.disabled },
          )}
        />
      </div>
    </div>
  );
};
